import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Playlist,
  VideoKeyBoardShortcutProvider,
  VideoPlay,
  usePlaylistCurrentlySelected,
  useVideoIsPlaying,
} from '@statsbomb/video-client-js';
import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import {
  USER_GROUP,
  USER_ROLES,
  VIDEO_JWT_CLAIMS,
} from '../../utils/constants/auth';
import { PlaylistContainer, VideoStyleWrapper } from './VideoPanel.styles';
import { trackVideoViewEvent } from '../../utils/helpers/snowplow';

const VideoPanel = ({
  data = [{}],
  showClipInfo = true,
  showVideo = true,
  handlePlaylistChange = () => {},
  children = null,
  isModal = false,
  fixedPlaylist = false,
}) => {
  const { user } = useKitbagAuth();
  const [currentlyPlayingPlay] = usePlaylistCurrentlySelected();

  const isAuthorised =
    user['https://statsbomb.com/accountID'] === USER_GROUP.STATSBOMB ||
    user[VIDEO_JWT_CLAIMS]?.roles.includes(USER_ROLES.VIDEO_CUSTOMER);

  useEffect(() => {
    handlePlaylistChange(currentlyPlayingPlay);
  }, [currentlyPlayingPlay]);

  // video analytics
  const isPlaying = useVideoIsPlaying();
  // Prevent double posting the same play id
  const lastTrackedId = useRef();
  useEffect(() => {
    if (
      isPlaying &&
      currentlyPlayingPlay?.id &&
      lastTrackedId.current !== currentlyPlayingPlay.id
    ) {
      trackVideoViewEvent(currentlyPlayingPlay.id);
      lastTrackedId.current = currentlyPlayingPlay.id;
    }
  }, [isPlaying, currentlyPlayingPlay]);

  // show playlist
  const showPlaylist = fixedPlaylist || data?.length > 1;

  return (
    <>
      {isAuthorised && showVideo && data && (
        <VideoKeyBoardShortcutProvider>
          <VideoStyleWrapper $isModal={isModal}>
            <VideoPlay
              controls
              autoPlay
              muted
              plays={data}
              testId="video-play"
            />
            {showClipInfo && children}
            {showPlaylist && (
              <PlaylistContainer $isModal={isModal}>
                <Playlist enableEditMode enableSelectAll />
              </PlaylistContainer>
            )}
          </VideoStyleWrapper>
        </VideoKeyBoardShortcutProvider>
      )}
      {!isAuthorised && showVideo && data && showClipInfo && children}
    </>
  );
};

VideoPanel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.arrayOf(PropTypes.object),
  showClipInfo: PropTypes.bool,
  showVideo: PropTypes.bool,
  handlePlaylistChange: PropTypes.func,
  children: PropTypes.node,
  // drive style adjustments for videoPanel
  isModal: PropTypes.bool,
  // is the playlist permanently shown
  fixedPlaylist: PropTypes.bool,
};

export default VideoPanel;
